if (!customElements.get('mats-catalog')) {
  customElements.define('mats-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('.ml-filter');
        if (button && this.contains(button)) this.filter(button.dataset.style);
        const pageButton = event.target.closest('.ml-page');
        if (pageButton && this.contains(pageButton)) {
          const grid = this.querySelector('.ml-grid');
          const gridTop = window.scrollY + grid.getBoundingClientRect().top;
          const offset = parseFloat(window.getComputedStyle(grid).scrollMarginTop) || 0;
          this.showPage(Number(pageButton.dataset.page));
          requestAnimationFrame(() => window.scrollTo({ top: gridTop - offset, behavior: 'auto' }));
        }
      });
      this.setupSecondaryImages();
      this.filter('all');
    }

    setupSecondaryImages() {
      // Only load hover images on hover-capable desktop devices
      const hoverMedia = window.matchMedia('(hover: hover) and (min-width: 750px)');
      if (!hoverMedia.matches) return;

      this.querySelectorAll('.ml-media--has-secondary').forEach((media) => {
        const placeholder = media.querySelector('.ml-media-image--secondary[data-secondary-srcset]');
        if (!placeholder) return;

        const loadImage = () => {
          const img = document.createElement('img');
          img.srcset = placeholder.dataset.secondarySrcset;
          img.sizes = placeholder.dataset.secondarySizes || '33vw';
          img.alt = placeholder.dataset.secondaryAlt || '';
          img.className = 'ml-media-image ml-media-image--secondary';
          img.loading = 'lazy';
          img.decoding = 'async';
          placeholder.replaceWith(img);
        };

        // Load on first hover or focus
        media.addEventListener('mouseenter', loadImage, { once: true });
        media.addEventListener('focusin', loadImage, { once: true });
      });
    }

    filter(wanted) {
      this.wanted = wanted;
      this.querySelectorAll('.ml-filter').forEach((button) => {
        const active = button.dataset.style === wanted;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      this.matches = Array.from(this.querySelectorAll('.ml-card')).filter((card) => {
        let styles;
        try { styles = JSON.parse(card.dataset.style); } catch { styles = card.dataset.style; }
        if (!Array.isArray(styles)) styles = [styles];
        return wanted === 'all' || styles.includes(wanted);
      });
      const count = this.matches.length;
      this.querySelector('.ml-count').textContent = count + ' ' + (count === 1 ? this.dataset.singular : this.dataset.plural);
      this.querySelector('.ml-empty').hidden = count > 0;
      this.showPage(1);
    }

    showPage(page) {
      const pageSize = Math.max(1, Number(this.dataset.pageSize) || 12);
      const pages = Math.ceil(this.matches.length / pageSize);
      this.page = Math.min(Math.max(1, page), Math.max(1, pages));
      const visible = new Set(this.matches.slice((this.page - 1) * pageSize, this.page * pageSize));
      this.querySelectorAll('.ml-card').forEach((card) => { card.hidden = !visible.has(card); });

      const pagination = this.querySelector('.ml-pagination');
      pagination.hidden = pages <= 1;
      const list = pagination.querySelector('.pagination__list');
      list.replaceChildren();
      if (pages <= 1) return;

      const addButton = (target, label, ariaLabel, current = false) => {
        const item = document.createElement('li');
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'pagination__item link ml-page';
        button.dataset.page = String(target);
        button.textContent = label;
        button.setAttribute('aria-label', ariaLabel);
        if (current) {
          button.classList.add('pagination__item--current', 'light');
          button.setAttribute('aria-current', 'page');
          button.disabled = true;
        }
        item.append(button);
        list.append(item);
      };
      if (this.page > 1) addButton(this.page - 1, '‹', 'Previous page');
      for (let number = 1; number <= pages; number++) {
        addButton(number, String(number), `Page ${number}`, number === this.page);
      }
      if (this.page < pages) addButton(this.page + 1, '›', 'Next page');
    }
  });
}
